















































































































































































import {
  Component,
  Vue
} from "vue-property-decorator";
import ContentPopUpContainer from "@/components/ContentPopUpContainer.vue";
import PopUpButton from './PopUpButton.vue';
@Component({
  components: {
    ContentPopUpContainer
  }
})
export default class ReferencesPopUp extends Vue {
  private refCount = 42
  private visible: boolean[] = [];
  created() {
    for (let i = 0; i < this.refCount; i++) {
      this.visible[i] = true;
    }
  }
  hideAllrefs() {
    for (let i = 0; i < this.refCount; i++) {
      this.visible[i] = false;
    }
  }
  setVisibleRefs(visibleRefs: number[]) {
    this.hideAllrefs();
    for (let i = 0; i < visibleRefs.length; i++) {
      console.log('got a ref:' + visibleRefs[i]);
      /* Don't forget to convert from one to zero based */
      this.visible[visibleRefs[i] - 1] = true;
    }
    /* For some reason we have to force an update to get it to render properly
       This is the official vue way of doing that */
    this.$forceUpdate();
  }
  showRefs() {
    (this.$refs.refpopup as PopUpButton).showPopUp();
  }
}
